/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function FAQSectionMinimal({
  faqs, title = '', subtitle = '', heading = '',
}) {
  const [expandedFAQ, setExpandedFAQ] = useState(-1);
  const [showAllFaqs, setShowAllFaqs] = useState(false);

  const toggleFAQ = (index) => {
    setExpandedFAQ(expandedFAQ === index ? -1 : index);
  };

  const cleanAnswer = (html) => {
    if (!html) return '';
    return html
      .replace(/<div[^>]*class="accordion-item[^"]*"[^>]*>/g, '')
      .replace(/<div[^>]*class="accordion-collapse[^"]*"[^>]*>/g, '')
      .replace(/<div[^>]*class="accordion-body"[^>]*>/g, '')
      .replace(/<\/div>/g, '');
  };

  const handleToggleShowAll = () => {
    if (showAllFaqs && expandedFAQ > 4) {
      setExpandedFAQ(-1);
    }
    setShowAllFaqs((prev) => !prev);
  };

  const visibleFaqs = (showAllFaqs ? faqs : faqs?.slice(0, 5)) || [];

  return (
    <div className="w-full flex flex-col justify-start items-center py-4">
      {
      heading && (
      <div className="flex gap-[10px] sm:gap-[11px] md:gap-[12px] items-center">
        <div className="w-[4px] sm:w-[5px] md:w-[6px] h-[24px] sm:h-[28px] md:h-[32px] bg-[#ff5761]" />
        <h2 className="text-[24px] sm:text-[27px] md:text-[30px]  font-semibold leading-[36px] sm:leading-[40px] md:leading-[45px] text-[#000]">
          {heading}
        </h2>
      </div>
      )
}
      {
        (title || subtitle)
        && (
        <div className="w-full flex flex-col items-center text-center mb-3">
          {title && <div dangerouslySetInnerHTML={{ __html: title }} />}
          {subtitle && <div dangerouslySetInnerHTML={{ __html: subtitle }} />}
        </div>
        )
      }

      <div className="flex flex-col gap-[12px] sm:gap-[14px] md:gap-[16px] w-full mt-[36px] sm:mt-[42px] md:mt-[48px] px-5 md:px-[80px]">
        {visibleFaqs.map((faq, index) => {
          const isLastVisible = index === visibleFaqs.length - 1;
          const hasMoreThanFive = faqs?.length > 5;

          return (
            <div
              key={index}
              className="flex flex-col gap-[6px] sm:gap-[7px] md:gap-[8px] w-full"
            >
              <div type="button" className="flex justify-between items-center w-full" onClick={() => toggleFAQ(index)}>
                <h4 className="text-[14px] cursor-pointer sm:text-[15px] md:text-[16px]  font-medium leading-[20px] sm:leading-[22px] md:leading-[24px] text-[#0A5BA3]">
                  {faq?.question}
                </h4>
                <button type="button" className="p-1">
                  <svg
                    className={`h-5 w-5 text-gray-500 transition-transform ${
                      expandedFAQ === index ? 'rotate-180' : ''
                    }`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
              </div>

              {expandedFAQ === index && (
              <div
                className="text-[12px] sm:text-[13px] md:text-[14px]  leading-[20px] sm:leading-[23px] md:leading-[26px] text-[#000] w-[88%] "
                dangerouslySetInnerHTML={{ __html: cleanAnswer(faq?.answer) }}
              />
              )}
              <div className="w-full flex items-center">
                <div className="flex-1 h-[1px] bg-[#00000019]" />
                {hasMoreThanFive && isLastVisible && (
                <button
                  type="button"
                  className="ml-3 text-[14px] sm:text-[15px] md:text-[16px] font-medium text-red-500 whitespace-nowrap"
                  onClick={handleToggleShowAll}
                >
                  {showAllFaqs ? 'Read Less..' : 'Read More...'}
                </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

FAQSectionMinimal.propTypes = {
  faqs: PropTypes.array.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  heading: PropTypes.string,
};
